import React, { useEffect, useState } from "react";
import axios from "axios";
import { UserConsumer } from "../../UserContext";
import moment from "moment";
import { Redirect, useHistory, useParams } from "react-router-dom";
import "./timeSheetStatus.css";
import { TimesheetStatusAPIs } from "./SpRole_TimesheetStatusAPI's";
import SelectCriteria from "./SelectCriteriaForm";
import TimeSheetStatusTable from "./TimesheetStatusTable";
import Header from "../../components/Header";
import { AlertPopups } from "../../components/AlertPopups";
import {
	GlobalPaginationSize,
	getPaginationSizeOnRole,
} from "../../components/GlobalPaginationSize";
import { dateCol } from "../ticketModule/variables/ListingVariables";
import { APIDateFormat } from "../Dashboard/DashboardVariables";
import { Routes } from "../../configurations/config";
import ActionFormatter from "./ActionFormatter";

const SpTimeSheetStatus = () => {
	const params = useParams();
	let history = useHistory();
	let token,
		joiningDate,
		employeeID,
		empDesignation = null;
	let empName = "";

	const [formFields, setFormFields] = useState({
		empID: empId,
		status: status,
		selectMonth: selectMonth,
		selectedYear: {
			value: new Date().getFullYear,
			label: new Date().getFullYear.toString(),
		},
	});
	const defaultSorted = [
		{
			dataField: "weekStart",
			order: "desc",
		},
	];
	const date = new Date();
	const currentYear = date.getFullYear();
	const [sortBy, setSortBy] = useState(defaultSorted[0]);
	const [isLoading, setIsLoading] = useState(true);
	const [getEmpNames, setGetEmpNames] = useState([]);
	const [status, setStatus] = useState(null);
	const [empId, setEmpId] = useState(null);
	const [selectedSupervisor, setSelectedSuperviosr] = useState(null);
	const [supervisorList, setSupervisorList] = useState(null);
	const [selectMonth, setSelectMonth] = useState(null);
	const [selectedYear, setSelectedYear] = useState({
		value: currentYear,
		label: currentYear.toString(),
	});
	const [flag, setFlag] = useState(false);
	const [employeeTimeSheets, setEmployeeTimeSheets] = useState([]);
	const [startDate, setStartDate] = useState();
	const submitBtnColor = "submit-btn";
	const [criteriaForm, setCriteriaForm] = useState({
		value: "",
		label: "",
	});
	const [yearsList, setYearsList] = useState([]);
	const [pageNum, setPageNum] = useState(1);
	const [numberOfItemsPerPage, setNumberOfItemsPerPage] = useState(
		GlobalPaginationSize.defaultPaginationSize
	);
	const [pagerData, setPagerData] = useState();
	const [showBtnLoading, setShowBtnLoading] = useState(false);

	const supervisor = [{ value: empName, label: empName }];
	const [myTimesheetStatus, setMyTimesheetStatus] = useState([]);
	const monthList = [
		{ value: 0, label: "All" },
		{ value: 1, label: "January" },
		{ value: 2, label: "February" },
		{ value: 3, label: "March" },
		{ value: 4, label: "April" },
		{ value: 5, label: "May" },
		{ value: 6, label: "June" },
		{ value: 7, label: "July" },
		{ value: 8, label: "August" },
		{ value: 9, label: "September" },
		{ value: 10, label: "October" },
		{ value: 11, label: "November" },
		{ value: 12, label: "December" },
	];

	const customActionFormatter = (row) => (
		<ActionFormatter
			weekStart={row.weekStart}
			employeeId={row.employeeId}
		/>
	);

	const columns = [
		{
			dataField: "employeeName",
			text: "Employee",
			sort: true,
		},
		{
			dataField: "supervisorName",
			text: "Supervisor",
			sort: true,
		},
		{
			dataField: "weekStart",
			text: "Week Start",
			sort: true,
			formatter: dateCol,
		},
		{
			dataField: "weekEnd",
			text: "Week End",
			sort: true,
			formatter: dateCol,
		},
		{
			dataField: "status",
			text: "Status",
			sort: false,
			style: (cell, row) => {
				switch (row.status) {
					case "Pending":
					case "InProgress":
					case "In Progress":
					case "Submitted":
						return { color: "#ffbe5c" };
					case "Approved":
						return { color: "#61b1b3" };
					case "Rejected":
					case "Not Created":
						return { color: "tomato" };
					default:
						return { color: "#61b1b3" };
				}
			},
		},
		{
			dataField: "action",
			text: "Action",
			formatter: (cell, row) => customActionFormatter(row),
		},
	];

	useEffect(() => {
		const pageSize = getPaginationSizeOnRole(empDesignation);
		setNumberOfItemsPerPage(pageSize);

		getEmpName();
		getSupervisorList();
		getTimesheetStatus();
		generateArrayOfYears();

		setEmpId(0);
		setFlag(false);
		setSelectMonth(0);
		setStatus(3);
		setFormFields({
			empID: { value: 0, label: "All" },
			status: { value: 3, label: "Submitted" },
			selectMonth: { value: 0, label: "All" },
			selectedYear: {
				value: new Date().getFullYear(),
				label: new Date().getFullYear().toString(),
			},
		});

		let UrlParams = new URLSearchParams(window.location.search);
		const empId = UrlParams.get("emp");

		if (empId) {
			//redirected from dashboard chart
			let Name = history.location.state.empName;
			let emp = {
				value: empId,
				label: Name,
			};
			setFormFields({
				...formFields,
				empID: emp,
			});
			setEmpId(empId);
			fetchData(empId, 0);
		} else if (params.value) {
			//redirected from supervisor dashboard
			fetchData(0, parseInt(params.value));
		} else {
			fetchData(0, 3);
		}
	}, []);

	const fetchData = (empId, status) => {
		let selectedMonth = { value: 0, label: "All" };
		const url = `${
			TimesheetStatusAPIs.GetEmpTimesheetStatus
		}?EmpId=${empId}&SupervisorId=${
			selectedSupervisor ? selectedSupervisor.value : employeeID
		}&Status=${status}&Year=${selectedYear.value}&Month=${
			selectedMonth.value
		}&PageSize=${getPaginationSizeOnRole(
			empDesignation
		)}&PageNumber=${pageNum}&SortBy=${sortBy.dataField}_${sortBy.order}`;

		axios
			.get(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(({ data, headers }) => {
				setIsLoading(false);
				setEmployeeTimeSheets(data.timesheets);
				setPagerData(JSON.parse(headers["x-pagination"]));
			})
			.catch((err) => {
				if (err.response) {
					AlertPopups.ErrorAlert.fire({
						text: `${err.response.data.message}`,
					});
				}
			});
	};

	const handleChange = (e) => {
		setFormFields({
			...formFields,
			["selectMonth"]: { value: e.value, label: e.label },
		});
		setCriteriaForm(e);
		setSelectMonth(e.value);
	};
	const getEmpName = () => {
		if (
			empDesignation?.toString() === "4" || //CM
			employeeID?.toString() === "232" || //Moazzam
			employeeID?.toString() === "180" //Abdullah
		) {
			axios
				.get(`${TimesheetStatusAPIs.GetSupEmpListForCM}`, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then(({ data }) => {
					const supEmpList = data.map((obj) => {
						return { value: obj.employeeId, label: obj.name };
					});
					let sorted = supEmpList.sort((a, b) =>
						a.label.localeCompare(b.label)
					);
					sorted.unshift({ value: 0, label: "All" });
					setGetEmpNames(sorted);
				});
		} else {
			axios
				.get(`${TimesheetStatusAPIs.GetSupEmpList}?isActive=true`, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then(({ data }) => {
					const supEmpList = data.employees.map((data) => {
						return {
							value: data.employeeId,
							label: data.employeeName,
						};
					});
					let sorted = supEmpList.sort((a, b) =>
						a.label.localeCompare(b.label)
					);
					sorted.unshift({ value: 0, label: "All" });
					setGetEmpNames(sorted);
				});
		}
	};
	const getSupervisorList = () => {
		axios
			.get(`${TimesheetStatusAPIs.GetSupervisorList}`, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then(({ data }) => {
				let empData = data.map((data) => {
					return {
						value: data.employeeId,
						label: data.name,
					};
				});
				empData = empData.sort((a, b) =>
					a.label.localeCompare(b.label)
				);
				setSupervisorList(empData);
				empData.unshift({ value: -1, label: "All" });
				let selectedSup = empData.find(
					(item) => item.value === parseInt(employeeID)
				);
				setSelectedSuperviosr(selectedSup);
			});
	};

	const getEmpTimesheetStatus = (obj) => {
		setFormFields({
			...formFields,
			["empID"]: { value: obj.value, label: obj.label },
		});
		setEmpId(obj.value);
	};
	const getYearStatus = (obj) => {
		setFormFields({
			...formFields,
			["selectedYear"]: { value: obj.value, label: obj.label },
		});
		setSelectedYear(obj);
	};
	const getEmpTimeSheet = (e) => {
		setIsLoading(true);

		e.preventDefault();
		axios
			.get(
				`${TimesheetStatusAPIs.GetEmpTimesheetStatus}?SupervisorId=${selectedSupervisor.value}&EmpId=${empId}&Status=${status}&Year=${selectedYear.value}&Month=${selectMonth}&PageSize=${numberOfItemsPerPage}&SortBy=${sortBy.dataField}_${sortBy.order}`,
				{ headers: { Authorization: `Bearer ${token}` } }
			)
			.then(({ data, headers }) => {
				setIsLoading(false);
				setEmployeeTimeSheets(data.timesheets);
				setPagerData(JSON.parse(headers["x-pagination"]));
			})
			.catch((err) => {
				if (err.response) {
					if (empId === null) {
						AlertPopups.ErrorAlert.fire({
							text: "Please Select Employee",
						});
					} else if (selectMonth === null) {
						AlertPopups.ErrorAlert.fire({
							text: "Please Select Month",
						});
					} else if (status === null) {
						AlertPopups.ErrorAlert.fire({
							text: "Please Select Status",
						});
					} else {
						AlertPopups.ErrorAlert.fire({
							text: `${err.response.data.message}`,
						});
					}
				}
			});
	};
	const getTimesheetStatus = () => {
		axios
			.get(`${TimesheetStatusAPIs.GetStatusTypes}`, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then(({ data }) => {
				let list = data.myTimesheetStatusTypes;
				list.unshift({ value: -1, label: "All" });
				setMyTimesheetStatus(
					list.sort((a, b) => a.label.localeCompare(b.label))
				);

				let UrlParams = new URLSearchParams(window.location.search);
				const empId = UrlParams.get("emp");
				if (empId) {
					setStatus(list[0]);
					setFormFields({
						empID: {
							value: empId,
							label: history.location.state.empName,
						},
						status: list.find((x) => x.value.toString() === empId),
						selectMonth: { value: 0, label: "All" },
						selectedYear: {
							value: new Date().getFullYear(),
							label: new Date().getFullYear().toString(),
						},
					});
				} else if (params.value) {
					setStatus(
						list.find((x) => x.value.toString() === params.value)
							.value
					);
					setFormFields({
						empID: { value: 0, label: "All" },
						status: list.find(
							(x) => x.value.toString() === params.value
						),
						selectMonth: { value: 0, label: "All" },
						selectedYear: {
							value: new Date().getFullYear(),
							label: new Date().getFullYear().toString(),
						},
					});
				} else {
					setStatus(3);
					setFormFields({
						empID: { value: 0, label: "All" },
						status: { value: 3, label: "Submitted" },
						selectMonth: { value: 0, label: "All" },
						selectedYear: {
							value: new Date().getFullYear(),
							label: new Date().getFullYear().toString(),
						},
					});
				}
			});
	};
	const handleStatus = (obj) => {
		setFormFields({
			...formFields,
			["status"]: { value: obj.value, label: obj.label },
		});
		setStatus(obj.value);
	};
	const handleSupervisorListChange = (obj) => {
		setSelectedSuperviosr(obj);
		axios
			.get(
				`${TimesheetStatusAPIs.GetSupervisorEmpListById}?SupervisorId=${obj.value}`,
				{
					headers: { Authorization: `Bearer ${token}` },
				}
			)
			.then(({ data }) => {
				let empData = data.employees.sort((a, b) => {
					a.label.localeCompare(b.label);
				});
				empData.unshift({ value: 0, label: "All" });

				setGetEmpNames(empData);
			});
	};

	const generateArrayOfYears = () => {
		const list = [];
		do {
			list.unshift({ value: joiningDate, label: joiningDate.toString() });
			joiningDate++;
		} while (joiningDate != currentYear + 1);
		setYearsList(list);
	};

	const getTimesheetDate = (obj) => {
		setStartDate(obj.weekStart);
		setFlag(true);
	};
	const exportToExcel = (e) => {
		e.preventDefault();
		setShowBtnLoading(true);
		axios({
			url: `${TimesheetStatusAPIs.ExportToExcel}?SupervisorId=${selectedSupervisor.value}&EmpId=${empId}&Status=${status}&Year=${selectedYear.value}&Month=${selectMonth}`,
			method: "GET",
			responseType: "blob",
			headers: {
				Authorization: `Bearer ${token}`,
			},
		})
			.then((response) => {
				const url = window.URL.createObjectURL(
					new Blob([response.data])
				);
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", "EmployeeTimesheetStatus.xlsx");
				document.body.appendChild(link);
				link.click();
				setShowBtnLoading(false);
			})
			.catch((err) => {
				if (err.response.data) {
					AlertPopups.ErrorAlert.fire({
						text: "Kindly Enter Month and Year",
					});
				}
				setShowBtnLoading(false);
			});
	};
	const receiveData = (PageSize) => {
		setIsLoading(true);

		axios
			.get(
				`${TimesheetStatusAPIs.GetEmpTimesheetStatus}?SupervisorId=${
					selectedSupervisor.value
				}&EmpId=${empId}&Status=${status}&Year=${
					selectedYear.value
				}&Month=${selectMonth}&PageSize=${PageSize}&PageNumber=${1}&SortBy=${
					sortBy.dataField
				}_${sortBy.order}`,
				{
					headers: { Authorization: `Bearer ${token}` },
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPageNum(1);
					setNumberOfItemsPerPage(PageSize);
					setEmployeeTimeSheets(res.data.timesheets);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
				}
			});
	};

	const handleTableChange = (type, { page, sortOrder, sortField }) => {
		setIsLoading(true);
		let getData = false;
		let apiURL = "";
		if (type === "sort") {
			apiURL = `${TimesheetStatusAPIs.GetEmpTimesheetStatus}?SupervisorId=${selectedSupervisor.value}&EmpId=${empId}&Status=${status}&Year=${selectedYear.value}&Month=${selectMonth}&SortBy=${sortField}_${sortOrder}&PageSize=${numberOfItemsPerPage}`;
			setSortBy({ dataField: sortField, order: sortOrder });
			getData = true;
		} else if (type === "pagination") {
			apiURL = `${TimesheetStatusAPIs.GetEmpTimesheetStatus}?SupervisorId=${selectedSupervisor.value}&EmpId=${empId}&Status=${status}&Year=${selectedYear.value}&Month=${selectMonth}&PageSize=${numberOfItemsPerPage}&PageNumber=${page}&SortBy=${sortBy.dataField}_${sortBy.order}`;
			getData = true;
		}

		if (getData) {
			axios
				.get(apiURL, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then((res) => {
					if (res.status === 200) {
						setIsLoading(false);
						setPageNum(page);
						setPagerData(JSON.parse(res.headers["x-pagination"]));
						setEmployeeTimeSheets(res.data.timesheets);
					}
				});
		}
	};
	const rowEvents = {
		onClick: (e, row) => {
			window.open(
				`${Routes.SpTimesheetStatus}?week=${moment(
					row.weekStart
				).format(APIDateFormat)}&emp=${row.employeeId}`,
				"_blank"
			);
		},
	};

	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				empName = userDetails.name;
				employeeID = userDetails.id;
				empDesignation = userDetails.designation;
				joiningDate = userDetails.empJoinedOn.split("-")[0];
				return userDetails.designation.toString() === "4" ||
					userDetails.empRole.includes("2") ||
					userDetails.empRole.includes("5") ||
					userDetails.empRole.includes("3") ? (
					<>
						<div className="container-fluid pl-3 pr-3">
							<Header
								title="Employee Timesheet Status"
								headerBorder={true}
							/>
							<SelectCriteria
								EmpList={getEmpNames}
								empName={empName}
								status={myTimesheetStatus}
								getEmpTimesheetStatus={getEmpTimesheetStatus}
								handleStatus={handleStatus}
								byMonth={monthList}
								handleChange={handleChange}
								criteriaForm={criteriaForm}
								joiningYear={yearsList}
								getEmpTimeSheet={getEmpTimeSheet}
								supervisorName={supervisor}
								getYearStatus={getYearStatus}
								exportToExcel={exportToExcel}
								showBtnLoading={showBtnLoading}
								submitBtnColor={submitBtnColor}
								selectedYear={selectedYear}
								formFields={formFields}
								recordFound={employeeTimeSheets.length}
								supervisorList={supervisorList}
								selectedSupervisor={selectedSupervisor}
								handleSupervisorListChange={
									handleSupervisorListChange
								}
								disableSupervisorDropdown={
									!(
										userDetails.id.toString() === "232" || //Moazzam
										userDetails.designation.toString() ===
											"4" || //CM
										userDetails.id.toString() === "180"
									)
								}
							/>
							<TimeSheetStatusTable
								tableData={employeeTimeSheets}
								getTimesheetDate={getTimesheetDate}
								flag={flag}
								setFlag={setFlag}
								startDate={startDate}
								empId={empId}
								tableLoader={isLoading}
								loading={isLoading}
								columns={columns}
								defaultSorted={defaultSorted}
								handleTableChange={handleTableChange}
								receiveData={receiveData}
								pagerData={pagerData}
								pageNum={pageNum}
								numberOfItemsPerPage={numberOfItemsPerPage}
								rowEvents={rowEvents}
							/>
						</div>
					</>
				) : (
					<Redirect to="/MyDashboard" />
				);
			}}
		</UserConsumer>
	);
};

export default SpTimeSheetStatus;
